import { textWithHTML, percentage } from 'Data/format.js'

export function getText(card_fee_percent) {
  return textWithHTML(
    `A <b>fee of ${percentage(
      card_fee_percent
    )}</b> will be applied to all credit card payments. This fee does not exceed the cost of acceptance for the credit card. This fee will not apply to debit card or ACH payments. By continuing, you acknowledge that the responsible party has authorized this fee.`
  )
}
